import { render, staticRenderFns } from "./CampaignItemIsLive.vue?vue&type=template&id=5c9533d5&scoped=true&"
import script from "./CampaignItemIsLive.vue?vue&type=script&lang=js&"
export * from "./CampaignItemIsLive.vue?vue&type=script&lang=js&"
import style0 from "./CampaignItemIsLive.vue?vue&type=style&index=0&id=5c9533d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9533d5",
  null
  
)

export default component.exports